"use client";
type PulseModule = typeof import("@/app/workspace/PulseTableBlock");
type HistoryModule = typeof import("@/app/workspace/ProductHistoryBlock");
let pulse: Promise<PulseModule> | null = null;
let history: Promise<HistoryModule> | null = null;
let loadedPulse: PulseModule | null = null;
let loadedHistory: HistoryModule | null = null;
/** Prepared code can mount directly instead of suspending again on a fulfilled
 * import. These are module references, never page instances or store data. */
export function getLoadedPulseTableModule() { return loadedPulse; }
export function getLoadedProductHistoryModule() { return loadedHistory; }
export function loadPulseTableModule() {
  return pulse ??= import("@/app/workspace/PulseTableBlock").then(module => { loadedPulse = module; return module; }).catch(error => { pulse = null; throw error; });
}
export function loadProductHistoryModule() {
  return history ??= import("@/app/workspace/ProductHistoryBlock").then(module => { loadedHistory = module; return module; }).catch(error => { history = null; throw error; });
}
export function preloadPulseCode() {
  void loadPulseTableModule().catch(() => {});
  void loadProductHistoryModule().catch(() => {});
}
export function preloadProductHistoryCode() { void loadProductHistoryModule().catch(() => {}); }
